// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'attachments.delete-all-dialog.heading',
		defaultMessage: 'Delete attachments',
		description: 'Heading to the dialog that allows users to delete all attachments under an issue',
	},
	deleteDetailsMessage: {
		id: 'attachments.delete-all-dialog.delete-details-message',
		defaultMessage:
			"You can't delete {nonDeletableCount} of these attachments. Either you don't have permission, or they're in issue fields and comments.",
		description:
			'A sentence explaining that a certain number of attachments cannot be deleted in bulk, either because the user lacks permission or they are in use elsewhere.',
	},
	deletingAllAttachmentsMessage: {
		id: 'attachments.delete-all-dialog.deleting-all-attachments',
		defaultMessage:
			'This action will permanently delete all {deletableCount} attachments in the attachments panel.',
		description:
			'A sentence detailing how many attachments will be deleted from an issue and that this is a permanent action.',
	},
	deletingAllAttachmentsMessageSingle: {
		id: 'attachments.delete-all-dialog.deleting-all-attachments-single',
		defaultMessage:
			'This action will permanently delete the 1 attachment in the attachments panel.',
		description:
			'A sentence detailing how many attachments will be deleted from an issue and that this is a permanent action.',
	},
	deletingSomeAttachmentsMessage: {
		id: 'attachments.delete-all-dialog.deleting-some-attachments',
		defaultMessage:
			'This action will permanently delete all other attachments in the attachments panel.',
		description:
			'A sentence explaining that all attachments will be deleted from an issue and that this is a permanent action.',
	},
	cancelButton: {
		id: 'attachments.delete-all-dialog.cancel-button-label',
		defaultMessage: 'Cancel',
		description: 'Label to the button abandoning the "delete all" action',
	},
	deleteButton: {
		id: 'attachments.delete-all-dialog.delete-button-label',
		defaultMessage: 'Delete',
		description: 'Label to the button that confirms the delete action',
	},
	deletingButton: {
		id: 'attachments.delete-all-dialog.deleting-button-label',
		defaultMessage: 'Deleting',
		description: 'Label to the button informing the user that the delete action is happening',
	},
	deleteAllFailedNotificationTitle: {
		id: 'attachments.delete-all-dialog.delete-all-failed-notification-title',
		defaultMessage: 'We couldn’t delete all your attachments',
		description: 'Notification title when deleting an attachment has failed',
	},
	deleteAllFailedNotificationDescription: {
		id: 'attachments.delete-all-dialog.delete-all-failed-notification-description',
		defaultMessage:
			'We didn’t finish deleting all your attachments for {issueKey}. Check your connection and then try again.',
		description:
			'Notification description when deleting an attachment has failed, potentially due to network',
	},
});
